export const getCarriersInfo = deliveryMethod => {
  const carriers = []
  const logosByUrl = new Map()

  if (deliveryMethod?.carriers) carriers.push(...deliveryMethod.carriers)
  if (deliveryMethod?.carrier_services) carriers.push(...deliveryMethod.carrier_services)

  carriers.forEach(carrier => {
    if (!carrier?.logo_url) return
    if (logosByUrl.has(carrier.logo_url)) return

    logosByUrl.set(carrier.logo_url, { logo_url: carrier.logo_url, name: carrier.name })
  })

  return [...logosByUrl.values()]
}

export const getStoreNames = (stores, deliveryMethod) => {
  return stores?.filter(store => deliveryMethod?.store_ids?.includes(store?.id)).map(store => store?.name)
}
